import React from 'react';
import { MapIcon, UtensilsIcon, ClockIcon } from 'lucide-react';
import { trackPurchase } from './MetaPixel';
export const Hero = () => {
  return <section className="bg-gradient-to-b from-teal-50 to-white py-10 sm:py-16 px-4 sm:px-6 lg:px-8" data-id="element-206">
      <div className="max-w-7xl mx-auto" data-id="element-207">
        <div className="block md:hidden mb-8" data-id="element-208">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qcd14hzumgTezoFuZPmCJj/01b9dd3d-81af-4f44-8956-979fb6224594.png" alt="Familia cocinando con Airfryer" className="rounded-lg shadow-xl w-full" data-id="element-209" />
        </div>
        <div className="flex flex-col lg:flex-row items-center gap-8" data-id="element-210">
          <div className="lg:w-1/2 space-y-5 text-center lg:text-left" data-id="element-211">
            <div className="bg-teal-100 text-teal-800 px-4 py-2 rounded-lg inline-block text-sm font-semibold mb-2 mx-auto lg:mx-0" data-id="element-212">
              Revisado por: Lic. Sofía Manfrini, Nutricionista (UBA)
            </div>
            <h1 className="text-3xl md:text-5xl font-bold text-gray-900 leading-tight" data-id="element-213">
              Recetario Fit para Airfryer
              <span className="block text-teal-600 text-2xl md:text-3xl mt-2" data-id="element-214">
                + 6 bonos gratis solo por hoy
              </span>
            </h1>
            <h2 className="text-xl md:text-3xl font-semibold text-teal-600" data-id="element-215">
              +60 recetas en menos de 15 min
            </h2>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 text-sm text-gray-700 bg-gray-50 p-3 rounded-lg" data-id="element-216">
              <span className="font-bold" data-id="element-217">4,9/5 ⭐️</span>
              <span className="mx-1" data-id="element-218">|</span>
              <span data-id="element-219">+2.800 descargas en Argentina</span>
              <span className="mx-1" data-id="element-220">|</span>
              <span data-id="element-221">8 de cada 10 lo usan 4+ veces por semana</span>
              <span className="mx-1" data-id="element-222">|</span>
              <span data-id="element-223">Actualizaciones gratis de por vida</span>
            </div>
            <div className="space-y-4" data-id="element-224">
              <div className="flex items-center justify-center lg:justify-start gap-3" data-id="element-225">
                <MapIcon className="h-6 w-6 text-teal-600 flex-shrink-0" data-id="element-226" />
                <p className="text-lg text-gray-700" data-id="element-227">
                  ¿Tenés airfryer pero no el mapa?
                </p>
              </div>
              <div className="space-y-2" data-id="element-228">
                <div className="flex items-center justify-center lg:justify-start gap-3" data-id="element-229">
                  <UtensilsIcon className="h-5 w-5 text-gray-600 flex-shrink-0" data-id="element-230" />
                  <p className="text-gray-700" data-id="element-231">Tenés el aparato.</p>
                </div>
                <div className="flex items-center justify-center lg:justify-start gap-3" data-id="element-232">
                  <ClockIcon className="h-5 w-5 text-gray-600 flex-shrink-0" data-id="element-233" />
                  <p className="text-gray-700" data-id="element-234">Tenés las ganas.</p>
                </div>
              </div>
              <p className="text-lg font-medium text-gray-800" data-id="element-235">
                Pero algo falta… y ya lo sentís.
              </p>
            </div>
            <p className="text-gray-700 italic" data-id="element-236">
              "Recetas simples, balanceadas y pensadas para la vida real: poco
              tiempo, mucho sabor y porciones claras."
            </p>
            <div className="pt-4 flex justify-center lg:justify-start" data-id="element-237">
              <a href="https://vhwt09-gz.myshopify.com/checkouts/cn/hWN3ajyOi9gyqJJTJgcXUW4g/es-ar?cart_link_id=CISumiVv&preview_theme_id=133233049643" className="inline-block bg-teal-600 hover:bg-teal-700 text-white font-bold py-3 px-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 text-lg w-full sm:w-auto text-center" onClick={trackPurchase} data-id="element-238">
                Quiero cocinar más rápido (y rico)
              </a>
            </div>
            <p className="text-sm text-gray-600 text-center lg:text-left" data-id="element-239">
              Ahorrá tiempo y plata: menos delivery, más casero rico en &lt;15
              min.
            </p>
          </div>
          <div className="hidden md:block lg:w-1/2 mt-6 lg:mt-0" data-id="element-240">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qcd14hzumgTezoFuZPmCJj/01b9dd3d-81af-4f44-8956-979fb6224594.png" alt="Familia cocinando con Airfryer" className="rounded-lg shadow-xl w-full" data-id="element-241" />
          </div>
        </div>
      </div>
    </section>;
};